export { OpenCloseComponent } from './open-close.component';
